import React from 'react'
import {
    AnalyticsTabs,FlexyRow,FlexyRowJustify
  } from '../../home/home.style';
import Cookies from 'js-cookie';
import { gql, useQuery,
} from '@apollo/client';
import { AnalyticsDuesTabs } from '../dues.style';
import { formatAmount, getCurrentMonth } from '../../../../../widget/util';


export const FETCH_DATA= gql`
query Facility_getDashboardData($facilityId: ID!, $duesTimelimit: Date!) {
  facility_getDashboardData(facilityId: $facilityId, duesTimelimit: $duesTimelimit) {
    propertyCount
    paidDuesAmount
    pendingDuesAmount
  }
}
`;
function DuesAnalyticsWidgetAll(props) {

  const facilityId = Cookies.get('facilityId');
  
  const { loading,error,data }  = useQuery(FETCH_DATA,{
    variables:{
      facilityId,
      duesTimelimit:"2024-12-31"
    }
  });
  
  console.log("fac",facilityId)
  
  if (loading) return <AnalyticsLoader/>;
  if (error) return <p>Error: {error.message}</p>;
  const dashboardData = data.facility_getDashboardData
  

  return (

    <div>
      <FlexyRow>
            <AnalyticsDuesTabs>
                <h5>Total Property</h5>
                <FlexyRowJustify>
                <h6 className='value'>{dashboardData.propertyCount}</h6>
                <button className='btn-flat btn transparent' >
                    <h6 style={{
                        color:"#22C55E"
                    }}>
                    {/* JUNE */}
                    {getCurrentMonth()}
                    </h6>
                </button>
                
                </FlexyRowJustify>   
            </AnalyticsDuesTabs>
            <AnalyticsDuesTabs>
                <h5>total dues pAID</h5>
                <FlexyRowJustify>
                <h6 className='value'>
                  N{formatAmount(parseFloat(dashboardData.paidDuesAmount))}
                </h6>
                <button className='btn-flat btn transparent' >
                    <h6 style={{
                        color:"#22C55E"
                    }}>
                    {/* JUNE */}
                    {getCurrentMonth()}
                    </h6>
                </button>
                
                </FlexyRowJustify>   
            </AnalyticsDuesTabs>
            <AnalyticsDuesTabs>
                <h5>TOTAL dues  oustanding</h5>
                <FlexyRowJustify>
                <h6 className='value'>N{
                dashboardData.pendingDuesAmount}</h6>
                <button className='btn-flat btn transparent' >
                    <h6 style={{
                        color:"#22C55E"
                    }}>
                    {/* JUNE */}
                    {getCurrentMonth()}
                    </h6>
                </button>
                
                </FlexyRowJustify>   
            </AnalyticsDuesTabs>
        </FlexyRow>


    </div>
  )
}

export default DuesAnalyticsWidgetAll





function AnalyticsLoader() {
  return (
    <div className='row'>
    <FlexyRow>
      
      <AnalyticsTabs>
        <h5>TOTAL DUES AMOUNT</h5>
        <FlexyRowJustify>
          <h6 className='value'>---</h6>
          <button className='btn-flat btn transparent' >
            <h6  >
              <i className='material-icons'>content_copy</i>
            </h6>
          </button>
          
        </FlexyRowJustify>   
      </AnalyticsTabs>

      <AnalyticsTabs>
        <h5>TOTAL DUES PAID </h5>
        <FlexyRowJustify>
          <h6 className='value'>---</h6>
          <h6 style={{
            color:"#22C55E"
          }}>
            JUNE
          </h6>
        </FlexyRowJustify>   
      </AnalyticsTabs>

      <AnalyticsTabs>
        <h5>TOTAL DUES OUTSTANDING</h5>
        <FlexyRowJustify>
          <h6 className='value'>---</h6>
          <h6 style={{
            color:"#EF4444"
          }}>
          JUNE
          </h6>
        </FlexyRowJustify>   
      </AnalyticsTabs>

     
     
    </FlexyRow>
  </div>
  )
}
